import { useState } from "react";

const EditIcon = ({
  color = "#2B363B",
  hoverColor = "#db0b27",
  width = 24,
  height = 24,
  opacity = 1,
  ...props
}) => {
  const [isHover, setIsHover] = useState(false);
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 18 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      role="img"
      aria-label="Icono editar"
      onMouseEnter={() => setIsHover(true)}
      onMouseLeave={() => setIsHover(false)}
      style={{ cursor: "pointer", ...props.style }}
      {...props}
    >
      <path
        d="M16.405 1.60002C16.1088 1.30375 15.7571 1.06874 15.3701 0.908396C14.983 0.748054 14.5682 0.665527 14.1492 0.665527C13.7302 0.665527 13.3154 0.748054 12.9283 0.908396C12.5413 1.06874 12.1896 1.30375 11.8934 1.60002L10.9767 2.51835C10.9308 2.55495 10.8889 2.59629 10.8517 2.64169L1.7517 11.7434C1.63534 11.8594 1.5559 12.0073 1.52336 12.1684L0.683363 16.335C0.655959 16.4697 0.662284 16.609 0.701774 16.7407C0.741265 16.8723 0.812695 16.9921 0.909704 17.0895C1.00671 17.1868 1.12629 17.2586 1.25778 17.2986C1.38928 17.3385 1.52861 17.3453 1.66336 17.3184L5.8367 16.485C5.99778 16.4525 6.14564 16.373 6.2617 16.2567L16.405 6.11335C16.7013 5.81713 16.9363 5.46544 17.0967 5.07839C17.257 4.69133 17.3395 4.27647 17.3395 3.85752C17.3395 3.43856 17.257 3.02371 17.0967 2.63665C16.9363 2.24959 16.7013 1.89791 16.405 1.60169M11.5034 4.35002L13.6584 6.50502L5.2617 14.9L2.56503 15.44L3.1067 12.7467L11.5034 4.35002ZM14.8367 5.32669L12.6817 3.17002L13.0717 2.78002C13.2125 2.63575 13.3805 2.52086 13.566 2.44199C13.7515 2.36313 13.9508 2.32186 14.1523 2.32059C14.3539 2.31932 14.5537 2.35806 14.7402 2.43457C14.9267 2.51108 15.0961 2.62384 15.2387 2.76632C15.3813 2.90879 15.4942 3.07815 15.5709 3.26457C15.6475 3.451 15.6864 3.65078 15.6853 3.85235C15.6842 4.05391 15.6431 4.25325 15.5643 4.43881C15.4856 4.62437 15.3709 4.79247 15.2267 4.93335L14.8367 5.32669Z"
        fill={isHover ? hoverColor : color}
        fillOpacity={opacity}
      />
    </svg>
  );
};

export default EditIcon;
